import React, { useState } from 'react'
import StatsComponent from '../common/StatsComponent'
import BarMixedCharts from '../common/BarChart'
import Linechart from './LineChart'
import HeatMap from '../common/HeatMap'
export default function Users() {
    const [tableData, settableData] = useState([])
    const [statsOption, setStatsOption] = useState({
        "Total Aggregators": "3,600",
        "Total Leads Received": "₹9,00,000",
        "Total Converted Leads": "₹9,00,000",
        "Overall Conversion Rate (%)": "₹3,000",
        "Total Disbursed Amount (₹)": "₹3,000",
        "Cost per Disbursed Loan (₹)": "₹3,600",
        "Revenue(₹)": "75%",

    })
    return (
        <>
            <div style={{marginTop:window.innerWidth > 1800 ? "57px" :""}}>
                <StatsComponent
                    Data={statsOption}
                />
            </div>

            <div className='row' style={{marginTop:window.innerWidth > 1800 ? "57px" :""}}>
                <div className="col-lg-4 col-xs-12">
                    <div style={{ marginTop: '10px' }}>
                        <BarMixedCharts
                            showFilters={false}
                            heading={"Lead vs Conversion Trend"}
                            AreaData={[]} xDataKeyName={""} BarDataKeyName={""} LineDataKeyName={""}
                            colorType={"purpleishRed"}
                            LegendLeft={"Leads Recieved"} LegendRight={"Converted Loans"}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-xs-12">
                    <div style={{ marginTop: '10px' }}>
                        <Linechart
                            colorType={"purpleishRed"}
                            heading={'Conversion Rate Trend(%)'}
                            Data={[]} xDataKeyName={""}
                            line1DataKeyName={"Agreegator A"} line2DataKeyName={"Agreegator B"}
                            line3DataKeyName={"Agreegator C"}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-xs-12">
                    <div style={{ marginTop: '10px' }}>
                        <HeatMap
                            heading={'Drop off HeatMap'}
                            Data={[]} 
                        />
                    </div>
                </div>
            </div>

            <div className="row" style={{marginTop:window.innerWidth > 1800 ? "57px" :""}}>
                <div className="col-xs-12">
                    <div className="customDash-table" style={{ marginTop: '20px' }}>
                        <div>
                            <h5>Aggregator wise Performance Table</h5>
                        </div>
                        <div className='main-customized-table'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th>Aggregator</th>
                                        <th>Leads</th>
                                        <th>Converted</th>
                                        <th>Conv %</th>
                                        <th>Disbursed ₹</th>
                                        <th>Avg Loan ₹</th>
                                        <th>Lead Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        tableData?.length > 0 ? tableData?.map((val, id) => {
                                            return (
                                                <tr key={id}>
                                                    <td></td>
                                                </tr>
                                            )
                                        })
                                            : ""}
                                    {/* <tr>
                            <td><div className='successTd'>PI Nam</div></td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                          </tr> */}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
